import { saveGraphApi, updateGraphApi, barLineAreaGraphApi } from '@/api/graph'
import { saveUserModuleAnalyticsSetting, updateStatForDashboard } from '@/api/analyticsSettings'
import { 
  createDashboardCard,
  getAllDisplayedDashboardCards,
  getPredefinedWidgetList,
  enablePredefinedWidget
} from '@/api/dashboard'

export const dashboardMixins = {
  created () {
    this.customer_id = localStorage.getItem('customer_id')
    this.getAllDashboardWidgets()
    this.getPredefinedWidgetList()
  },
  data () {
    return {
      customer_id: null,
      allPredefinedWidgetList: [],
      allWidgetsToDisplay: [],
      allWidgetsToDisplay_meta: null,
      idToUpdate: null,
      previewData: null
    }
  },
  methods: {
    async getPredefinedWidgetList () {
      try {
        const response = await getPredefinedWidgetList()
        this.allPredefinedWidgetList = response.data.data.card
      } catch (e) {
        console.log(e)
      }
    },
    async enablePredefinedWidget (value) {
      try {
        const response = await enablePredefinedWidget(this.customer_id, value)
        if (response.status === 201) {
          this.allWidgetsToDisplay.push({...response.data.data.card})
          this.showSuccessMessage('Success', 'Predefined card added successfully', 'success')
        }
      } catch (e) {
        this.showSuccessMessage('Error', e.data.message, 'danger')
      }
    },
    async createWidget () {
      if (this.createWidgetType === 'graph') {
        if (this.dialogMode === 'Add') {
          this.saveGraph()
        } else {
          this.updateGraph()
        }
      } else if (this.createWidgetType === 'stat') {
        if (this.dialogMode === 'Add') {
          this.saveStat()
        } else {
          this.updateStat()
        }
      }
    },
    async saveGraph () {
      // Create graph widget
      const { graph_type, module_id, x_axis, y_axis, time_period, card_name } = this.graphCreationPayload
      const payload = {
        x_axis,
        y_axis,
        platform_module_id: module_id,
        graph_type,
        name: card_name,
        additional_data: {
          date_setting: time_period
        },
        is_saved: false
      }

      try {
        const response = await saveGraphApi(this.customer_id, payload)

        if (response.status === 201) {
          const cardPayload = { card_type: this.createWidgetType.toUpperCase(), entity_id: response.data.data.graphs.id }
          const newCard = await createDashboardCard(this.customer_id, cardPayload)

          if (newCard.status === 201) {
            //console.log({...newCard.data.data.card})
            this.allWidgetsToDisplay.push({...newCard.data.data.card})
            this.showSuccessMessage('Success', 'Graph card added successfully', 'success')
            this.closeWidgetsSelectDialog()
          }
        }
      } catch (error) {
        this.showSuccessMessage('Error', error.data.message, 'danger')
        this.closeWidgetsSelectDialog()
      }
    },
    async saveStat () {
      const { 
        is_enabled, 
        module_id, 
        option_id, 
        price_range, 
        value_for, 
        time_period, 
        card_name 
      } = this.statCreationPayload

      const payload = {
        customer_id: this.customer_id,
        module_id,
        option_id: is_enabled,
        value_id: is_enabled === 17 ? [option_id] : option_id,
        from_price: price_range[0],
        to_price: price_range[1],
        value_for,
        name: card_name,
        date_setting: time_period
      }

      try {
        const response = await saveUserModuleAnalyticsSetting(payload)

        if (response.status === 200) {
          const cardPayload = { card_type: this.createWidgetType.toUpperCase(), entity_id: response.data.data.module_analytics.id }
          const newCard = await createDashboardCard(this.customer_id, cardPayload)

          if (newCard.status === 201) {
            //console.log({...newCard.data.data.card})
            this.allWidgetsToDisplay.push({...newCard.data.data.card})
            this.showSuccessMessage('Success', 'Stat card added successfully', 'success')
            this.closeWidgetsSelectDialog()
          }
        }
      } catch (error) {
        if (error.status === 501) {
          this.showSuccessMessage('Error', 'Failed to create new card', 'danger')
        } else {
          this.showSuccessMessage('Error', error.data.message, 'danger')
        }
        
        this.closeWidgetsSelectDialog()
      }
    },
    async getAllDashboardWidgets () {
      try {
        const { data } = await getAllDisplayedDashboardCards(this.customer_id)
        this.allWidgetsToDisplay = data.data.card
        this.allWidgetsToDisplay_meta = data.data.meta
      } catch (error) {
        console.log(error)
      }
    },
    removeWidget (widget_id) {
      const index = this.allWidgetsToDisplay.findIndex(item => item.id === widget_id)
      if (index > -1) {
        this.allWidgetsToDisplay.splice(index, 1)
      }
    },
    editWidget (widget_data) {
      // console.log(widget_data)
      this.openWidgetsSelectDialog('Edit')
      this.createWidgetType = widget_data.widget_type
      
      if (this.createWidgetType === 'graph') {
        this.graphCreationPayload = {
          graph_type: widget_data.data.graph_type,
          module_id: widget_data.data.platform_module_id,
          x_axis: '',
          y_axis: '',
          time_period: widget_data.data.additional_data.date_setting,
          card_name: widget_data.data.name
        }

        this.idToUpdate = widget_data.data.id

        this.getXAxisList()
        this.graphCreationPayload.x_axis = widget_data.data.x_axis

        this.getYAxisList()
        this.graphCreationPayload.y_axis = widget_data.data.y_axis

      } else if (this.createWidgetType === 'stat') {
        this.statCreationPayload = {
          module_id: widget_data.data.stats.module_id,
          time_period: widget_data.data.analytics.date_setting,
          card_name: widget_data.data.analytics.name,
          is_enabled: null,
          parent_option_id: null,
          option_id: null,
          price_range: [100, 500],
          value_for: 1
        }

        this.idToUpdate = widget_data.data.analytics.id

        this.getModuleStatSettings()
        this.statCreationPayload.is_enabled = widget_data.data.stats.id
        this.statCreationPayload.parent_option_id = widget_data.data.analytics.selected_parent_option_id

        this.statCreationPayload.option_id = widget_data.data.stats.id === 17 ? widget_data.data.analytics.multiple_value_id[0] : widget_data.data.analytics.value_id
        this.statCreationPayload.price_range = [widget_data.data.analytics.from_price, widget_data.data.analytics.to_price]

        //console.log(this.statCreationPayload)
      }
    },
    async updateGraph () {
      const { graph_type, module_id, x_axis, y_axis, time_period, card_name } = this.graphCreationPayload
      const payload = {
        x_axis,
        y_axis,
        platform_module_id: module_id,
        graph_type,
        name: card_name,
        additional_data: {
          date_setting: time_period
        }
      }

      try {
        const response = await updateGraphApi(this.customer_id, this.idToUpdate, payload)

        if (response.status === 201) {
          const index = this.allWidgetsToDisplay.findIndex(item => item.entity_id === this.idToUpdate)
          if (index > -1) {
            const valueAtIndex = this.allWidgetsToDisplay[index]
            this.allWidgetsToDisplay.splice(index, 1, {
              ...valueAtIndex,
              graph: response.data.data.graph,
              graph_data: response.data.data.graph_data
            })
          }

          this.showSuccessMessage('Success', 'Graph card updated successfully', 'success')
          this.closeWidgetsSelectDialog()
        }
      } catch (error) {
        this.showSuccessMessage('Error', error.data.message, 'danger')
        this.closeWidgetsSelectDialog()
      }

    },
    async updateStat () {
      const { 
        is_enabled, 
        module_id, 
        option_id, 
        price_range, 
        value_for, 
        time_period, 
        card_name 
      } = this.statCreationPayload

      const payload = {
        customer_id: this.customer_id,
        module_id,
        option_id: is_enabled,
        value_id: is_enabled === 17 ? [option_id] : option_id,
        from_price: price_range[0],
        to_price: price_range[1],
        value_for,
        name: card_name,
        date_setting: time_period,
        id: this.idToUpdate
      }

      try {
        const response = await updateStatForDashboard(payload)

        if (response.status === 200) {
          const index = this.allWidgetsToDisplay.findIndex(item => item.entity_id === this.idToUpdate)
          if (index > -1) {
            const valueAtIndex = this.allWidgetsToDisplay[index]
            this.allWidgetsToDisplay.splice(index, 1, {
              ...valueAtIndex,
              analytics: response.data.data.analytics,
              stat: response.data.data.stat
            })
          }
          this.showSuccessMessage('Success', 'Stat card updated successfully', 'success')
          this.closeWidgetsSelectDialog()
        }
      } catch (error) {
        if (error.status === 501) {
          this.showSuccessMessage('Error', 'Failed to update new card', 'danger')
        } else {
          this.showSuccessMessage('Error', error.data.message, 'danger')
        }
        this.closeWidgetsSelectDialog()
      }
    },
    async filterGraph (data) {
      try {
        const response = await barLineAreaGraphApi(this.customer_id, data.payload)

        if (response.status === 201) {
          const index = this.allWidgetsToDisplay.findIndex(item => item.id === data.card_id)
          if (index > -1) {
            const valueAtIndex = this.allWidgetsToDisplay[index]
            this.allWidgetsToDisplay.splice(index, 1, {
              ...valueAtIndex,
              graph_data: { ...response.data.data }
            })
          }
        }
      } catch (e) {
        //console.log(e)
      } 
    },
    async getPreview () {
      if (this.createWidgetType === 'graph') {
        this.previewGraph()
      } else if (this.createWidgetType === 'stat') {
        this.previewStat()
      }
    },
    async previewGraph () {
      const { graph_type, module_id, x_axis, y_axis, time_period, card_name } = this.graphCreationPayload

      const payload = {
        additional_data: {
          date_setting: time_period
        },
        platform_module_id: module_id,
        x_axis,
        y_axis
      }

      try {
        const response = await barLineAreaGraphApi(this.customer_id, payload)
        if (response.status === 201) {
          this.previewData = {
            graph: {
              x_axis,
              y_axis,
              platform_module_id: module_id,
              graph_type,
              name: card_name,
              additional_data: {
                start_date: null,
                end_date: null,
                date_setting: time_period
              }
            },
            graph_data: { ...response.data.data }
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async previewStat () {

    }
  }
}